<template>
  <header class="sitenav">
    <!-- top menu -->
    <div class="sitenav__menu">
      <router-link
        :to="{ name: 'Products' }"
        class="flex justify-center items-center pr-1 pl-2 md:pr-4 md:pl-6"
      >
        <img class="sitenav__brand" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTA4cHgiIGhlaWdodD0iMTk2cHgiIHZpZXdCb3g9IjAgMCAxMDggMTk2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1Ny4xICg4MzA4OCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+VW50aXRsZWQgY29weTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJsb2dvLXNob3J0IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cG9seWdvbiBpZD0ib3V0bGluZSIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSI0Mi40NjA2ODU5IDE0MS43NDU5MDQgMjEuMjcyNDM5OSAxNTQuOTE2OTc2IDAgMTQxLjk4MTAzMyAwIDEzLjI1NjMzMzcgMjEuMDI1MTMxNCAwLjI5NTYzNjgzOCA0Mi4yMzQzOTYyIDEzLjQ3OTc3NDkgNDIuOTMzNjcyNSA2Mi44OTUyNzcgNTAuNjA3ODc0MSA2Ny42NTg1NzUxIDY1LjUwMTE2NiA1OC40Nzc3Nzk2IDY1LjUwMTE2NiA1NC43Njc0OTE0IDg2Ljk2NjMwOTEgNDEuMzE2MDAxMyAxMDggNTQuMjgxOTc1OCAxMDggODQuNTkyNTA5NyA5Mi4xNDkxODQgOTQuNjE1ODE5NyA5Mi4xNDkxODQgOTguMzQyNzI2MyA3Ni4zMTI2NzEyIDEwOC4zNzk5NTQgOTIuMTQ5MTg0IDExOC40MTcxODEgOTIuMTQ5MTg0IDE0Mi42NTY5MDcgMTA4IDE1Mi42ODAyMTcgMTA4IDE4Mi45OTA3NTIgODYuOTc0ODY4NyAxOTUuOTUxNDQ5IDY1Ljc1NTM4NDQgMTgyLjc2MDk2IDY1LjUyMjMxODUgMTU4LjI4OTAxNCA0OC45NTEwNDkgMTQ4LjAxOTQ5NSA0OC45NTEwNDkgMTIzLjMxNjY1OCA0Mi44NDMzNjk5IDExOS41NTAyNTYiPjwvcG9seWdvbj4KICAgICAgICAgICAgPHBhdGggZD0iTTEwMi4zNjgyOTgsMTU3LjQ0NzU1MiBMMTAyLjM2ODI5OCwxNzkuNTkyMDc1IEw4OC4xNDkxODQsMTg4LjY4Mjk4NCBMODguMTQ5MTg0LDE2Ni4zMDUzNjEgTDEwMi4zNjgyOTgsMTU3LjQ0NzU1MiBaIE04Ni45ODM2ODMsMTQ2LjI1ODc0MSBMMTAyLjEzNTE5OCwxNTUuNTgyNzUxIEw4Ni45ODM2ODMsMTY0LjkwNjc2IEw3Mi4yOTgzNjgsMTU1LjU4Mjc1MSBMODYuOTgzNjgzLDE0Ni4yNTg3NDEgWiBNODUuODE4MTgyLDEyMi40ODI1MTcgTDg1LjgxODE4MiwxNDUuMDkzMjQgTDcxLjU5OTA2OCwxNTMuOTUxMDQ5IEw3MS41OTkwNjgsMTMxLjM0MDMyNiBMODUuODE4MTgyLDEyMi40ODI1MTcgWiBNMzYuODY3MTMzLDExNi4xODg4MTEgTDM2Ljg2NzEzMywxMzguNzk5NTM0IEwyMS45NDg3MTgsMTQ3LjY1NzM0MyBMMjEuOTQ4NzE4LDEyNS4wNDY2MiBMMzYuODY3MTMzLDExNi4xODg4MTEgWiBNNzAuNjY2NjY3LDExMS41MjY4MDcgTDg1LjU4NTA4MiwxMjAuODUwODE2IEw3MC40MzM1NjYsMTI5Ljk0MTcyNSBMNTUuNTE1MTUyLDEyMC44NTA4MTYgTDcwLjY2NjY2NywxMTEuNTI2ODA3IFogTTIxLjk0ODcxOCwxMDEuOTY5Njk3IEwzNi44NjcxMzMsMTExLjA2MDYwNiBMMzYuODY3MTMzLDExNC4wOTA5MDkgTDIxLjk0ODcxOCwxMjIuNzE1NjE4IEwyMS45NDg3MTgsMTAxLjk2OTY5NyBaIE01NS4yODIwNTEsOTguMjQwMDkzIEw2OS41MDExNjYsMTA2Ljg2NDgwMiBMNjkuNTAxMTY2LDExMC4xMjgyMDUgTDU1LjI4MjA1MSwxMTguOTg2MDE0IEw1NS4yODIwNTEsOTguMjQwMDkzIFogTTcxLjU5OTA2OCw4My43ODc4NzkgTDg1LjgxODE4Miw5Mi40MTI1ODcgTDg1LjgxODE4Miw5NS45MDkwOTEgTDcxLjU5OTA2OCwxMDQuNzY2OSBMNzEuNTk5MDY4LDgzLjc4Nzg3OSBaIE01Mi40ODQ4NDgsNzcuNDk0MTcyIEw1Mi40ODQ4NDgsOTQuMjc3Mzg5IEwzOC45NjUwMzUsODUuODg1NzgxIEw1Mi40ODQ4NDgsNzcuNDk0MTcyIFogTTEwMi4zNjgyOTgsNTguODQ2MTU0IEwxMDIuMzY4Mjk4LDgxLjQ1Njg3NiBMODguMTQ5MTg0LDkwLjMxNDY4NSBMODguMTQ5MTg0LDY3LjcwMzk2MyBMMTAyLjM2ODI5OCw1OC44NDYxNTQgWiBNMzcuNTY2NDM0LDY2LjMwNTM2MSBMNTIuNDg0ODQ4LDc1LjYyOTM3MSBMMzcuNTY2NDM0LDg0LjcyMDI4IEwyMy4xMTQyMTksNzYuMDk1NTcxIEwyMy4xMTQyMTksNzUuMzk2MjcgTDM3LjU2NjQzNCw2Ni4zMDUzNjEgWiBNNjkuNTAxMTY2LDYzLjA0MTk1OCBMNjkuNTAxMTY2LDgwLjI5MTM3NSBMNTUuNTE1MTUyLDcxLjY2NjY2NyBMNjkuNTAxMTY2LDYzLjA0MTk1OCBaIE0zNi44NjcxMzMsNDIuMjk2MDM3IEwzNi44NjcxMzMsNjQuNjczNjYgTDIxLjk0ODcxOCw3My41MzE0NjkgTDIxLjk0ODcxOCw1MS4zODY5NDYgTDM2Ljg2NzEzMyw0Mi4yOTYwMzcgWiBNODYuOTgzNjgzLDQ3Ljg5MDQ0MyBMMTAxLjY2ODk5OCw1Ny4yMTQ0NTIgTDg2Ljk4MzY4Myw2Ni4zMDUzNjEgTDcyLjA2NTI2OCw1Ny4yMTQ0NTIgTDg2Ljk4MzY4Myw0Ny44OTA0NDMgWiBNMzYuMTY3ODMyLDE4LjA1MzYxMyBMMzYuODY3MTMzLDQwLjE5ODEzNSBMMjEuOTQ4NzE4LDQ5LjUyMjE0NSBMMjEuOTQ4NzE4LDI2LjkxMTQyMiBMMzYuMTY3ODMyLDE4LjA1MzYxMyBaIE0yMS4yNDk0MTcsNi44NjQ4MDIgTDM1LjkzNDczMiwxNi4xODg4MTEgTDIxLjAxNjMxNywyNS4yNzk3MiBMNi4zMzEwMDIsMTYuMTg4ODExIEwyMS4yNDk0MTcsNi44NjQ4MDIgWiIgaWQ9IndoaXRlLWZpbGwiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTIxLjAxNjMxNyw1IEwzOC4yNjU3MzQsMTUuNzIyNjExIEwzOC45NjUwMzUsNjUuMTM5ODYgTDUyLjQ4NDg0OCw3My41MzE0NjkgTDUyLjQ4NDg0OCw3MS4yMDA0NjYgTDY5LjUwMTE2Niw2MC43MTA5NTYgTDY5LjUwMTE2Niw1Ni45ODEzNTIgTDg2Ljk4MzY4Myw0Ni4wMjU2NDEgTDEwNCw1Ni41MTUxNTIgTDEwNCw4Mi4zODkyNzcgTDg4LjE0OTE4NCw5Mi40MTI1ODcgTDg4LjE0OTE4NCw5Ni4xNDIxOTEgTDcxLjU5OTA2OCwxMDYuNjMxNzAyIEw3MS41OTkwNjgsMTEwLjEyODIwNSBMODguMTQ5MTg0LDEyMC42MTc3MTYgTDg4LjE0OTE4NCwxNDQuODYwMTQgTDEwNCwxNTQuODgzNDUgTDEwNCwxODAuNzU3NTc2IEw4Ni45ODM2ODMsMTkxLjI0NzA4NiBMNjkuNzM0MjY2LDE4MC41MjQ0NzYgTDY5LjUwMTE2NiwxNTYuMDQ4OTUxIEw1Mi45NTEwNDksMTQ1Ljc5MjU0MSBMNTIuOTUxMDQ5LDEyMS4wODM5MTYgTDM4Ljk2NTAzNSwxMTIuNDU5MjA3IEwzOC40OTg4MzQsMTM5LjQ5ODgzNCBMMjEuMjQ5NDE3LDE1MC4yMjE0NDUgTDQsMTM5LjczMTkzNSBMNCwxNS40ODk1MSBMMjEuMDE2MzE3LDUgWiBNMTAyLjM2ODI5OCwxNTcuNDQ3NTUyIEw4OC4xNDkxODQsMTY2LjMwNTM2MSBMODguMTQ5MTg0LDE4OC42ODI5ODQgTDEwMi4zNjgyOTgsMTc5LjU5MjA3NSBMMTAyLjM2ODI5OCwxNTcuNDQ3NTUyIFogTTg2Ljk4MzY4MywxNDYuMjU4NzQxIEw3Mi4yOTgzNjgsMTU1LjU4Mjc1MSBMODYuOTgzNjgzLDE2NC45MDY3NiBMMTAyLjEzNTE5OCwxNTUuNTgyNzUxIEw4Ni45ODM2ODMsMTQ2LjI1ODc0MSBaIE04NS44MTgxODIsMTIyLjQ4MjUxNyBMNzEuNTk5MDY4LDEzMS4zNDAzMjYgTDcxLjU5OTA2OCwxNTMuOTUxMDQ5IEw4NS44MTgxODIsMTQ1LjA5MzI0IEw4NS44MTgxODIsMTIyLjQ4MjUxNyBaIE0zNi44NjcxMzMsMTE2LjE4ODgxMSBMMjEuOTQ4NzE4LDEyNS4wNDY2MiBMMjEuOTQ4NzE4LDE0Ny42NTczNDMgTDM2Ljg2NzEzMywxMzguNzk5NTM0IEwzNi44NjcxMzMsMTE2LjE4ODgxMSBaIE03MC42NjY2NjcsMTExLjUyNjgwNyBMNTUuNTE1MTUyLDEyMC44NTA4MTYgTDcwLjQzMzU2NiwxMjkuOTQxNzI1IEw4NS41ODUwODIsMTIwLjg1MDgxNiBMNzAuNjY2NjY3LDExMS41MjY4MDcgWiBNMjEuOTQ4NzE4LDEwMS45Njk2OTcgTDIxLjk0ODcxOCwxMjIuNzE1NjE4IEwzNi44NjcxMzMsMTE0LjA5MDkwOSBMMzYuODY3MTMzLDExMS4wNjA2MDYgTDIxLjk0ODcxOCwxMDEuOTY5Njk3IFogTTU1LjI4MjA1MSw5OC4yNDAwOTMgTDU1LjI4MjA1MSwxMTguOTg2MDE0IEw2OS41MDExNjYsMTEwLjEyODIwNSBMNjkuNTAxMTY2LDEwNi44NjQ4MDIgTDU1LjI4MjA1MSw5OC4yNDAwOTMgWiBNNzEuNTk5MDY4LDgzLjc4Nzg3OSBMNzEuNTk5MDY4LDEwNC43NjY5IEw4NS44MTgxODIsOTUuOTA5MDkxIEw4NS44MTgxODIsOTIuNDEyNTg3IEw3MS41OTkwNjgsODMuNzg3ODc5IFogTTUyLjQ4NDg0OCw3Ny40OTQxNzIgTDM4Ljk2NTAzNSw4NS44ODU3ODEgTDUyLjQ4NDg0OCw5NC4yNzczODkgTDUyLjQ4NDg0OCw3Ny40OTQxNzIgWiBNMTAyLjM2ODI5OCw1OC44NDYxNTQgTDg4LjE0OTE4NCw2Ny43MDM5NjMgTDg4LjE0OTE4NCw5MC4zMTQ2ODUgTDEwMi4zNjgyOTgsODEuNDU2ODc2IEwxMDIuMzY4Mjk4LDU4Ljg0NjE1NCBaIE0zNy41NjY0MzQsNjYuMzA1MzYxIEwyMy4xMTQyMTksNzUuMzk2MjcgTDIzLjExNDIxOSw3Ni4wOTU1NzEgTDM3LjU2NjQzNCw4NC43MjAyOCBMNTIuNDg0ODQ4LDc1LjYyOTM3MSBMMzcuNTY2NDM0LDY2LjMwNTM2MSBaIE02OS41MDExNjYsNjMuMDQxOTU4IEw1NS41MTUxNTIsNzEuNjY2NjY3IEw2OS41MDExNjYsODAuMjkxMzc1IEw2OS41MDExNjYsNjMuMDQxOTU4IFogTTM2Ljg2NzEzMyw0Mi4yOTYwMzcgTDIxLjk0ODcxOCw1MS4zODY5NDYgTDIxLjk0ODcxOCw3My41MzE0NjkgTDM2Ljg2NzEzMyw2NC42NzM2NiBMMzYuODY3MTMzLDQyLjI5NjAzNyBaIE04Ni45ODM2ODMsNDcuODkwNDQzIEw3Mi4wNjUyNjgsNTcuMjE0NDUyIEw4Ni45ODM2ODMsNjYuMzA1MzYxIEwxMDEuNjY4OTk4LDU3LjIxNDQ1MiBMODYuOTgzNjgzLDQ3Ljg5MDQ0MyBaIE0zNi4xNjc4MzIsMTguMDUzNjEzIEwyMS45NDg3MTgsMjYuOTExNDIyIEwyMS45NDg3MTgsNDkuNTIyMTQ1IEwzNi44NjcxMzMsNDAuMTk4MTM1IEwzNi4xNjc4MzIsMTguMDUzNjEzIFogTTIxLjI0OTQxNyw2Ljg2NDgwMiBMNi4zMzEwMDIsMTYuMTg4ODExIEwyMS4wMTYzMTcsMjUuMjc5NzIgTDM1LjkzNDczMiwxNi4xODg4MTEgTDIxLjI0OTQxNyw2Ljg2NDgwMiBaIiBpZD0icmVkLWZyYW1lIiBmaWxsPSIjRUEyNjJEIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=">
      </router-link>

      <!-- Mobile Menu -->
      <ui-hamburger
        @toggle="toggleNavigation"
        :active="showNavigation"
      />

      <div
        class="sitenav__mobile-overlay"
        @click="toggleNavigation"
        :class="{
          'bm-overlay': !showNavigation,
          'bm-overlay-active': showNavigation,
        }"
      />

      <div
        class="sitenav__mobile-menu"
        :class="{
          'mb-menu-wrap': !showNavigation,
          'mb-menu-wrap-active': showNavigation,
        }"
      >
        <div class="bm-menu">
          <nav class="bm-item-list">
            <a :href="websiteOriginUrl + '/cs/karmen-story/'" class="bm-item">Příběh</a>
            <a :href="websiteOriginUrl + '/cs/blog/'" class="bm-item">Blog</a>
            <a :href="websiteOriginUrl + '/cs/docs/'" class="bm-item">Dokumentace</a>
            <router-link :to="{ name: 'Products' }" class="bm-item">E-shop</router-link>
            <a href="https://forum.karmen.tech/" class="bm-item">Komunita</a>
            <a href="https://next.karmen.tech/" class="bm-item">Přihlásit</a>
          </nav>
        </div>
      </div>
      <!-- END Mobile Menu -->

      <div class="relative flex items-center w-full">
        <a :href="websiteOriginUrl + '/'" class="sitenav__link sitenav__company">Karmen</a>
        <a :href="websiteOriginUrl + '/cs/karmen-story/'" class="sitenav__link">Příběh</a>
        <a :href="websiteOriginUrl + '/cs/blog/'" class="sitenav__link">Blog</a>
        <a :href="websiteOriginUrl + '/cs/docs/'" class="sitenav__link">Dokumentace</a>
        <router-link :to="{ name: 'Products' }" class="sitenav__link">E-shop</router-link>
        <a href="https://forum.karmen.tech/" class="sitenav__link">Komunita</a>

        <!-- right aligned menu items -->
        <div class="absolute right-0 flex items-center pr-18 md:pr-24 xl:pr-0">
          <button
            @click="showCurrencyMenu = !showCurrencyMenu"
            type="button"
            id="currency-menu"
            aria-haspopup="true"
            class="btn clear px-2"
          >
            <span class="sr-only">Open currency menu</span>
            <div class="flex flex-row">
              <div class="text-xs">{{ $store.getters['common/currentCurrency'].name }}</div>
            </div>
          </button>

          <ui-context-menu
            :show="showCurrencyMenu"
            @close="showCurrencyMenu = false"
            mobileTitle="Měna"
          >
            <ui-context-menu-item
              v-for="curr of currencies"
              :key="curr.code"
              @click="setCurrency(curr)"
            >
              {{ curr.name }}
            </ui-context-menu-item>
          </ui-context-menu>

          <router-link :to="{ name: 'Cart' }" class="sitenav__link">
            <ui-icon name="cart" class="h-4 w-4" />
          </router-link>

          <router-link :to="{ name: 'Cart' }" class="block xl:hidden ml-4">
            <ui-icon name="cart" class="h-4 w-4" />
          </router-link>

          <!-- language switch -->
          <!-- <div class="relative flex-shrink-0 border ml-2">
            <div>
              <button
                @click="showLanguageMenu = !showLanguageMenu"
                type="button"
                id="currency-menu"
                aria-haspopup="true"
                class="btn clear px-2"
              >
                <span class="sr-only">Open language menu</span>
                <div class="flex flex-row">
                  <div class="mr"><ui-icon name="chevron-up" class="h-4 w-4" /></div>
                  <div>{{ $store.getters['common/currentLanguage'].name }}</div>
                </div>
              </button>
            </div>
            <ui-context-menu
              :show="showLanguageMenu"
              @close="showLanguageMenu = false"
            >
              <ui-context-menu-item
                v-for="lang of languages"
                :key="lang.code"
                @click="setLanguage(lang)"
              >
                {{ lang.name }}
              </ui-context-menu-item>

            </ui-context-menu>
          </div> -->
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
.sitenav {
  @apply fixed top-0 bg-white-100 bg-opacity-70;

  width: calc(100% - (100% - 100vw)); /* posune o kousek navku aby neskákala když zmizí scrollbar na overflow hidden */
  backdrop-filter: saturate(180%) blur(10px);
  z-index: 1000;
}

.sitenav__brand {
  height: 1.95rem;
  margin-bottom: 4px;
  @apply md:h-12 w-8;
}

.sitenav__menu {
  @apply flex items-stretch h-12 md:h-18 mx-auto uppercase;

  max-width: 74rem;
}

.sitenav__link {
  @apply
    hidden xl:flex items-center
    xl:h-full
    px-6
    text-xs text-gray-700 font-normal
    hover:text-red-400;

  letter-spacing: 2px;
  line-height: normal;
}

.sitenav__company {
  @apply
    flex
    md:mr-9 lg:mr-15 pl-0
    font-title font-semibold text-xl md:text-2xl;

  letter-spacing: .01rem;
}

.router-link-active {
  @apply text-red-400;
}

.sitenav__mobile-menu {
  @apply fixed right-0 p-6 top-12 md:top-18;

  z-index: 1100;
  width: 13.5rem;
  height: calc(100vh - 3rem);
  transition: all 0.5s ease 0s;
  background: hsla(0,0%,100%,.89);
  backdrop-filter: saturate(180%) blur(10px);
}

.bm-menu {
  @apply h-full;
}

.mb-menu-wrap {
  @apply fixed right-0;

  z-index: 1100;
  width: 13.5rem;
  transition: all 0.5s ease 0s;
  transform: translate3d(100%, 0px, 0px);
}

.mb-menu-wrap-active {
  @apply fixed right-0;

  z-index: 1100;
  width: 13.5rem;
  transition: all 0.5s ease 0s;
}

.bm-item-list {
  @apply block h-full;
}

.sitenav__mobile-menu .bm-item {
  @apply block text-black-900 font-normal;

  font-size: .9rem;
  margin-bottom: -1.203rem;
  line-height: 3rem;
  padding-top: 1.203rem;
  text-transform: uppercase;
  letter-spacing: 4px;
  outline: none;
}

.sitenav__mobile-overlay {
  @apply top-12 md:top-18;
  backdrop-filter: saturate(80%) blur(4px);
}

.bm-overlay {
  @apply fixed w-full opacity-0;

  z-index: 1000;
  height: calc(100vh - 3rem);
  background: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s ease 0s, transform 0s ease 0.3s;
  transform: translate3d(100%, 0px, 0px);
}
.bm-overlay-active {
  @apply fixed w-full opacity-100;

  z-index: 1000;
  height: calc(100vh - 3rem);
  background: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s ease 0s;
}

</style>

<script>
import uiIcon from '@/components/ui/uiIcon.vue';
import uiContextMenu from '@/components/ui/uiContextMenu.vue';
import uiContextMenuItem from '@/components/ui/uiContextMenuItem.vue';
import uiHamburger from '@/components/ui/uiHamburger.vue';

export default {
  name: 'AppHeader',

  components: {
    uiIcon,
    uiContextMenu,
    uiContextMenuItem,
    uiHamburger,
  },

  watch:{
    $route (){
      document.body.classList.remove('overflow-hidden');
    }
  },

  data: () => ({
    languages: null,
    currencies: null,
    showCurrencyMenu: false,
    showLanguageMenu: false,
    showNavigation: false,
    websiteOriginUrl: process.env.VUE_APP_WEBSITE_ORIGIN_URL
  }),

  created: function() {
    this.languages = this.$store.getters['common/languages'];
    this.currencies = this.$store.getters['common/currencies'];
  },

  methods: {
    setLanguage(item) {
      this.currentLanguage = item;
      this.$store.commit('common/setCurrentLanguage', item);
      this.showLanguageMenu = false;
    },
    setCurrency(item) {
      this.currentCurrency = item;
      this.$store.commit('common/setCurrentCurrency', item);
      this.showCurrencyMenu = false;
    },
    toggleNavigation() {
      this.showNavigation = !this.showNavigation;
    }
  }
};
</script>
